// src/blocks/icon/SVGs/close.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CloseSVG = ({
  title = "Close Icon",
  desc = "Close Icon",
  descId,
  width = 16,
  height = 16,
  ...props
}) => {
  const titleId = React.useId();
  const decriptionId = React.useId();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-labelledby": titleId,
      "aria-describedby": decriptionId,
      ...props,
      children: [
        desc ? /* @__PURE__ */ jsx("desc", { id: decriptionId, children: desc }) : null,
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx("path", { id: "Line 53", d: "M3 3L13 13", stroke: "currentColor" }),
        /* @__PURE__ */ jsx("path", { id: "Line 56", d: "M3 13L13 3", stroke: "currentColor" })
      ]
    }
  );
};
var close_default = CloseSVG;

export {
  close_default
};
